<template>
  <div class="$attrs.class">
    <label class="upper">PRIMAY CONTACT</label>
    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent="save"
      >
        <div class="form-row">
          <div class="col-12">
            <input-text
              id="name"
              v-model="name"
              name="name"
              label="Name"
              type="text"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <input-text
              id="title"
              v-model="title"                   
              name="title"
              label="Title"
              type="text"
            />
          </div>

          <div class="col-12 col-md-6">
            <input-text
              id="phoneNumber"
              v-model="phoneNumber"
              name="phoneNumber"
              label="Phone Number"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12">
            <input-text
              id="email"
              v-model="email"
              name="email"
              label="Email"
              type="text"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="col-12 col-md-6">
            <input-select
              id="contactInCrisis"
              v-model="contactInCrisis"
              name="contactInCrisis"
              label="Contact in Crisis"
              type="checkbox"
              :options="[
                { id: 'true', display_label: 'Yes' },
                { id: 'false', display_label: 'No' }
              ]"
            />
          </div>
        </div>

        <button
          type="submit"
          class="btn btn-primary btn-wide mt-4"
        >
          <font-awesome-icon
            v-if="school.saving"
            :spin="true"
            :icon="['fas', 'spinner']"
            class="icon alt"
          />
          <span v-else>Save Changes</span>
        </button>
      </form>
    </form-component>
  </div>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'PrimaryContact',

  components: {
    FormComponent,
    InputText,
    InputTextArea,
    InputSelect,
  },

  inject:['school'],

  data() {
    return {
      name: '',
      title: '',
      phoneNumber: '',
      email: '',
      contactInCrisis: 'false',
    }
  },

  mounted() {
    this.name = this.school.primaryContact.name;
    this.title = this.school.primaryContact.title;
    this.phoneNumber = this.school.primaryContact.phoneNumber;
    this.email = this.school.primaryContact.email;
    this.contactInCrisis = this.school.primaryContact.contactInCrisis ? 'true' : 'false';
  },

  methods: {
    async save() {
      const isValid = await this.$validator.validateAll()
      if (!isValid)
        return;

      this.errors.clear();

      try {
        await this.school.updatePrimaryContact({
          name: this.name,
          title: this.title,
          phoneNumber: this.phoneNumber,
          email: this.email,
          contactInCrisis: this.contactInCrisis === 'true',
        });
        this.$store.commit('setGlobalAlert', {
          msg: 'Primary Contact Saved!',
        });
      } catch {
        this.$store.commit('setGlobalAlert', {
          msg: 'Failed to save primary contact. Please try again!', error: true,
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
label.upper {
    @include label;

    color: $green;
    margin-bottom: 20px;
  }
</style>